
import Vue from 'vue'
// import themeMixin from '@/mixins/themeMixin'

// import JCenterCol from '@/ui/controls/JCenterCol.vue'

export default Vue.extend({
  components: {
    // JCenterCol,
  },
  // mixins: [themeMixin],
})
